import { render, staticRenderFns } from "./LocAndHour.vue?vue&type=template&id=70f8eec8&scoped=true&"
import script from "./LocAndHour.vue?vue&type=script&lang=js&"
export * from "./LocAndHour.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f8eec8",
  null
  
)

export default component.exports